module.exports = __webpack_public_path__ + "static/img/lct.a385cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lct.png
// module id = J8iq
// module chunks = 1